import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const AvatarStack = styled.div`
  position: absolute;
  left: 18px;
  bottom: 76px;
  display: flex;

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid var(--white);
    margin-left: -10px;

    &:first-child {
      margin-left: 0;
    }

    &.a1 {
      background: var(--purple);
    }
    &.a2 {
      background: var(--grey);
    }
    &.a3 {
      background: var(--green);
    }
  }
`;

const Bubble = styled.div`
  position: absolute;
  right: 18px;
  bottom: 18px;
  left: 96px;
  padding: 12px 16px;
  border-radius: 16px 16px 4px 16px;
  background: rgba(var(--blackr), 0.55);
  backdrop-filter: blur(2px);
  color: var(--white);
  font-size: 12px;
  line-height: 1.4;
  font-weight: 500;
`;

const questions = [
  "Find every public company with direct exposure to uranium demand from AI data centers.",
  "Which semiconductor companies have expanded margins while growing revenue over the past decade?",
  "Show every major supplier and customer of NVIDIA.",
  "Find undervalued companies with growing free cash flow.",
  "Which ETFs increased AI infrastructure exposure over the last year?",
  "Compare Amazon, Microsoft, Google, and Oracle cloud businesses.",
  "Which companies have the strongest improving earnings sentiment?",
  "Which economic events impact gold miners the most?",
  "Find companies with significant revenue exposure to Europe.",
  "How has Tesla's global supply chain changed since 2022?",
  "Rank the largest U.S. banks by financial strength.",
  "Find stocks with rising analyst estimates but negative sentiment.",
  "Build a watchlist of high-quality compounder stocks.",
  "Why has ASML outperformed the semiconductor industry?",
  "Generate a DCF valuation for Adobe.",
  "Show every ETF holding Rocket Lab.",
  "Which industries have the fastest improving sentiment?",
  "Compare Apple today with Apple in 2016 using point-in-time data.",
  "Find companies with improving web traffic and hiring trends.",
  "Screen for companies with rising ROIC and insider buying."
];

const rand = <T,>(arr: T[]) => arr[Math.floor(Math.random() * arr.length)];
const ChatBubble = () => {
  return (
    <Wrapper>
      <AvatarStack>
        <span className="avatar a1" />
        <span className="avatar a2" />
        <span className="avatar a3" />
      </AvatarStack>
      <Bubble>{rand(questions)}</Bubble>
    </Wrapper>
  );
};

export default ChatBubble;
